// src/pages/usa/puertorico/Arecibo.js
import "../../../App.css";
import Header from "../../../components/Header";
import Footer from "../../../components/Footer";
import BackOnly from "../../../components/BackOnly";
import ContactPopup from "../../../components/ContactPopup";
import React, { useState, useEffect } from "react";
import AffiliateBooking from "../../../components/affiliate/AffiliateBooking";
import AffiliateExpedia from "../../../components/affiliate/AffiliateExpedia";
import AffiliateTrip from "../../../components/affiliate/AffiliateTrip";

import { useNavigate } from "react-router-dom";   // ⭐ REQUIRED

// ⭐ STRICT COMMAND: Arecibo ALWAYS goes back to Puerto Rico map
export const backRoute = "/map/puertorico";

export default function Arecibo() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  // ⭐ Send strict back command to BackOnly
  useEffect(() => {
    navigate(".", { state: { backRoute } });
  }, [navigate]);

  return (
    <>
      <Header />

      <div className="visited-back-wrapper">
        <BackOnly />
      </div>


      <div className="page-container" style={{ padding: "12px" }}>
        <h1>Arecibo, Puerto Rico</h1>

        <section className="travel-review">
          {/* LEFT COLUMN */}
          <div className="travel-text">
            <h2>🏞️ Discover Arecibo, Puerto Rico</h2>

            <p>
              Arecibo, located on the northern coast of Puerto Rico, is a city rich in
              history, culture, and natural beauty. Known for its stunning beaches, lush
              landscapes, and the famous Arecibo Observatory — which sadly collapsed in
              2020 — this destination offers a unique blend of attractions for travelers
              seeking both adventure and relaxation.
            </p>

            <h3>🚗 Getting There</h3>

            <p>
              Arecibo is easily accessible by car from San Juan via PR‑22, about a
              one‑hour drive. Public transportation exists, but renting a car is the best
              option for exploring beaches, caves, and scenic coastal roads.
            </p>

            <h3>🌟 My Personal Observation</h3>

            <ul>
              <li>
                <div className="place-block">
                  <strong>Cueva del Indio:</strong> A dramatic coastal cave system known
                  for ancient petroglyphs and sweeping ocean views. The cliffside vantage
                  point alone is worth the visit.
                  <br />
                  <a
                    href="https://www.google.com/maps?q=18.492698944792803,-66.6416239966227"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 View on Google Maps
                  </a>
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Arecibo Lighthouse:</strong> A historical park with ocean views,
                  a small museum, and nearby beaches. I ate at Islote Beach Restaurant —
                  excellent food and atmosphere.
                  <br />
                  <a
                    href="https://www.google.com/maps?q=18.48160086283586,-66.69886739812601"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 View on Google Maps
                  </a>
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Cueva Ventana (Window Cave):</strong> A natural balcony
                  overlooking the Río Grande de Arecibo valley. Guided tours protect the
                  ecosystem and provide geological and cultural insight.
                  <br />
                  <a
                    href="https://www.google.com/maps?q=18.370757, -66.690760"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 View on Google Maps
                  </a>
                </div>
              </li>
            </ul>

            <h3>🥾 Other Hidden Gems</h3>

            <ul>
              <li>
                <div className="place-block">
                  <strong>Driving Around Arecibo:</strong> Explore the Catholic church,
                  town square, and colonial architecture. Nearby towns like Hatillo,
                  Camuy, and Barceloneta offer their own unique charm.
                </div>
              </li>
            </ul>

            <h3>🛏️ Places to Stay in Arecibo (Nov 2025)</h3>

            <p>
              While I usually visit Arecibo on day trips, these well‑rated options are
              great for overnight stays. Always double‑check availability and reviews.
            </p>

           
            <ul>
              <li>
                <div className="place-block">
                  <strong>Ventana al Atlantico Boutique Hotel:</strong> Oceanfront views,
                  though reviews suggest checking cleanliness before booking.
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Vacation Rental Arecibo PR:</strong> Quiet, beachfront, and
                  relaxing — guests love the ocean sounds.
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Las Olas Beach Apartments:</strong> Simple, budget‑friendly, and
                  right on the beach.
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>BednBong Experience Stay:</strong> Creative atmosphere and
                  welcoming hosts — highly rated.
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Casita Linda:</strong> Extended‑stay option with a home‑like
                  feel.
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Casita del Mar #1 Oceanfront Retreat:</strong> Private terrace
                  and peaceful coastal views.
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Arecibo Inn:</strong> Budget‑friendly with pool and breakfast.
                  Some guests mention mold concerns — check reviews.
                </div>
              </li>
            </ul>

           <h3>If you are looking for a place to stay, you can check prices, date and time here.</h3>
            <div className="affiliate-block">
              <AffiliateExpedia />
              <AffiliateBooking />
              <AffiliateTrip />
            </div>
            <h3>🎥 My Travel Videos</h3>

            <p>
              Here are some videos I filmed at Cueva del Indio. Set the quality to 1080p
              or higher for best viewing.
            </p>

            <p>
              <a
                href="https://youtu.be/Kk8_HIUqM1s?si=79jwjjIPVC6LkYGN"
                target="_blank"
                rel="noopener noreferrer"
              >
                Cueva del Indio
              </a>
            </p>

            <p>
              <a
                href="https://youtu.be/AkQ55E3E3RU?si=EX9yH8ae1zUbcpqr"
                target="_blank"
                rel="noopener noreferrer"
              >
                Cueva del Indio — 360 View
              </a>
            </p>

            <p>
              <a
                href="https://youtu.be/tYH4t4j7XUc?si=ar8zmRBkQFjgLZhk"
                target="_blank"
                rel="noopener noreferrer"
              >
                Outside Cueva del Indio — 360 View
              </a>
            </p>
          </div>

          {/* RIGHT COLUMN */}
          <div className="travel-image-column">
            <a
              href="https://youtu.be/Kk8_HIUqM1s?si=i2Vq1Mqba7NKbN8N"
              target="_blank"
              rel="noopener noreferrer"
              className="youtube-image-card"
            >
              <img
                src="/images/usa/puertorico/arecibo/cuevadelindio.jpg"
                alt="Cueva del Indio Video"
              />
            </a>

            <a
              href="https://youtu.be/LLIrLBfjYM0?si=VfxlYAkjVbE_JVzV"
              target="_blank"
              rel="noopener noreferrer"
              className="youtube-image-card"
            >
              <img
                src="/images/usa/puertorico/arecibo/monument.jpg"
                alt="Monumento a Colón"
              />
            </a>

            <img
              src="/images/usa/puertorico/arecibo/cuevaview.jpg"
              alt="Cueva del Indio View"
            />
            <img
              src="/images/usa/puertorico/arecibo/cuevainside.jpg"
              alt="Cueva del Indio Inside"
            />
            <img
              src="/images/usa/puertorico/arecibo/beachview.jpg"
              alt="Beach View"
            />
            <img
              src="/images/usa/puertorico/arecibo/town.jpg"
              alt="Catholic Church in Arecibo"
            />
            <img
              src="/images/usa/puertorico/arecibo/cuevaventana.jpg"
              alt="Cueva Ventana"
            />
            <img
              src="/images/usa/puertorico/arecibo/cuevaventana1.jpg"
              alt="Cueva Ventana"
            />
          </div>
        </section>
      </div>

      <div className="email-wrapper">
        <button className="email-link" onClick={() => setOpen(true)}>
          contact@thefindingspot.com
        </button>
      </div>

      <ContactPopup isOpen={open} onClose={() => setOpen(false)} />

      <Footer />
    </>
  );
}
